export default __webpack_public_path__ + "static/media/news.e8c490dc.png";